{
  "version": 1,
  "asset_id": "6b1b3ca8-ba83-4726-a428-b15a74924562",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/6b1b3ca8-ba83-4726-a428-b15a74924562/brand-blueox.png",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/6b1b3ca8-ba83-4726-a428-b15a74924562/brand-blueox.png",
  "original_filename": "brand-blueox.png",
  "size": 21295,
  "content_type": "image/png",
  "created_at": "2026-07-14T02:53:41Z"
}
